let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dBQ0u")).then(() => parcelRequire('gQpn0'));